import React, { useState } from 'react';

import Icon from '~/shared/components/iconsExporter';
import { ScrollRight } from './styles';

const ScrollArrow = () => {
  const [slideLeft, setSlideLeft] = useState(0);

  const moveRight = () => {
    const el = document.getElementById(`hscroll`);
    setSlideLeft((el.scrollLeft += 489));
  };

  return (
    <ScrollRight>
      <Icon
        onClick={moveRight}
        name="next"
        color="gray3"
        size="30"
        slideleft={slideLeft}
      />
    </ScrollRight>
  );
};

export default ScrollArrow;
